import React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Testimonial from "./Testimonials";
import SuccessStories from "./SuccessStories";
import "./Home.css";
import Features from "./Features";
import Navbar from "./Navbar";
import NavbarStudents from "../Dashboard/Navbarlogedin";
import NavbarProfessionals from "../Interviewer/NavbarInterviewer";
import Professional from "./TwoColWithButton";
import Pricing from "./Pricing";
import Hero from "./TwoColumnWithInput";
import Footer from "./Footer";
import FAQS from "./FAQs";
import Partners from "./Partner/index.jsx";
import Working from "./HowitWorks";

const changeLink = () => {
  const links = document.querySelectorAll(".nav-item a");
  links.forEach((link) => {
    if (link.classList.contains("active")) {
      link.classList.remove("active");
    }
    if (link.innerHTML === "Home") {
      link.classList.add("active");
    }
  });
};

const Home = () => {
  const user = JSON.parse(localStorage.getItem("isIAuthenticated"));
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    changeLink();
  }, []);

  return (
    <>
      {!user?.role ? <Navbar /> : null}
      {user?.role === "Student" ? <NavbarStudents /> : null}
      {user?.role === "Interviewer" ? <NavbarProfessionals /> : null}
      <div className="mt-16" id="home">
        <Hero />
      </div>
      <div id="howItWorks">
        <Working />
      </div>
      <div id="features">
        <Features />
      </div>
      <div id="profiles">
        <Professional />
      </div>
      <div id="pricing">
        <Pricing />
      </div>
      <div id="partners">
        <Partners />
      </div>
      <div id="testimonials">
        <SuccessStories />
        {/* <Testimonial /> */}
      </div>
      <div id="faqs">
        <FAQS />
      </div>
      <Footer />
    </>
  );
};

export default Home;
